import React, { useState } from "react";
import { Stack } from "@mui/material";
import {
  Container,
  InputLabel,
  Instruction,
  VerifyButton,
  Title,
  OTP,
  ResendOtpLink,
} from "./verifyOtp.components";
import { useAlert } from "react-alert";
import { useLocation, useNavigate } from "react-router-dom";
import { homepage, loginLink, resetPasswordLink } from "../../../common/routes";
import { useCookies } from "react-cookie";
import { forgotPassword, verifyOTP } from "../../../services/auth";

function VerifyOtp() {
  const alert = useAlert();
  const navigate = useNavigate();
  const [cookies] = useCookies();
  const { state } = useLocation();
  let [otpValue, setOtpValue] = useState();
  const [loader, setLoader] = useState(false);

  if (cookies.token !== undefined && cookies.token !== "undefined")
    navigate(homepage);
  if (state === null) navigate(loginLink);

  const handleVerifyOtp = async () => {
    if (!otpValue || otpValue.length !== 5) {
      alert.error("please enter a valid otp");
      return;
    }

    const optData = {
      emailID: state.emailID,
      otp: otpValue,
    };
    await verifyOTP(optData)
      .then((response) => {
        if (response.status !== 200) {
          alert.error(response.data.message);
          return;
        }
        alert.success(response.data.message);
        navigate(resetPasswordLink, {
          state: { otp: otpValue, emailID: state.emailID },
        });
      })
      .catch((error) => console.log(error));
  };

  return (
    <Container>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="flex-start"
        spacing={2.5}
        sx={{ py: 5.75, width: 480, m: "auto" }}
      >
        <Title>Reset Password</Title>
        <Instruction>Enter the OTP sent to your registered mail id</Instruction>
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="flex-start"
          spacing={2}
        >
          <InputLabel>Enter Otp</InputLabel>
          <OTP
            value={otpValue}
            onChange={setOtpValue}
            autoFocus
            OTPLength={5}
            otpType="number"
            disabled={false}
          />
        </Stack>
        <VerifyButton onClick={handleVerifyOtp}>Verify</VerifyButton>
        {/* functionality for below link is similar as 'SEND OTP' button of forgot password page */}
        <ResendOtpLink loading={loader} onClick={handleResendOtp}>
          Resend OTP
        </ResendOtpLink>
      </Stack>
    </Container>
  );

  async function handleResendOtp() {
    setLoader(true);
    await forgotPassword({ emailID: state.emailID })
      .then((response) => {
        if (response.status !== 200) {
          alert.error(response.data.message);
          return;
        }
        setLoader(false);
        alert.success(response.data.message);
      })
      .catch((error) => console.log(error));
  }
}

export default VerifyOtp;
